// src/i18n.js (다국어 추가 버전)
import { debugLog } from './utils/environment';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

// [진단용 로그 1] 이 파일이 실행되는지 확인
debugLog("i18n.js: 파일 로드 시작");

/**
 * [보안 강화] 조건부 디버그 모드 설정
 * 프로덕션에서는 i18next 디버그 로그를 완전 차단
 */
const getDebugMode = () => {
  // 환경 변수 우선 확인
  const envDebug = process.env.REACT_APP_DEBUG;
  if (envDebug === 'false') {
    return false;
  }
  
  // 개발 환경에서만 활성화 (보안 강화)
  const isDev = process.env.NODE_ENV === 'development';
  
  return isDev;
};

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // [핵심 수정] 조건부 디버그 모드 - 프로덕션에서 로그 차단
    debug: getDebugMode(),

    // [수정] 33개 언어 지원
    supportedLngs: [
      'ko',     // 한국어
      'en',     // English
      'es',     // Español
      'ja',     // 日本語
      'zh-TW',  // 繁體中文
      'zh',     // 简体中文
      'vi',     // Tiếng Việt
      'id',     // Bahasa Indonesia
      'ms',     // Bahasa Melayu
      'th',     // ไทย
      'fil',    // Filipino
      'hi',     // हिन्दी
      'bn',     // বাংলা
      'ur',     // اردو
      'de',     // Deutsch
      'fr',     // Français
      'tr',     // Türkçe
      'pt',     // Português (Brasil)
      'ar',     // العربية
      'fi',     // Suomi
      'my',     // မြန်မာဘာသာ
      'af',      // Afrikaans
      'ru',     // Русский
      'fa',     // فارسی
      'uk',     // Українська
      'pl',     // Polski
      'it',     // Italiano
      'sw',     // Swahili
      'ml',     // മലയാളം
      'nl',     // Nederlands
      'ro',     // Română
      'ne',     // नेपाली
      'el'      // Ελληνικά
    ],
    
    fallbackLng: 'en',
    
    detection: {
      // --- 여기가 최종 핵심 수정 부분입니다 ---
      // 'navigator'를 추가하여 브라우저의 언어 설정을 감지하도록 순서를 조정합니다.
      order: ['cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['cookie', 'localStorage'],
      
      // [추가] 언어 코드 변환 매핑
      // 브라우저가 제공하는 언어 코드를 앱에서 사용하는 코드로 변환
      convertDetectedLanguage: (lng) => {
        // 중국어 간체 변환: zh-CN, zh-Hans → zh
        if (lng === 'zh-CN' || lng === 'zh-Hans' || lng.startsWith('zh-CN')) {
          return 'zh';
        }
        // 중국어 번체는 그대로 유지
        if (lng === 'zh-TW' || lng === 'zh-Hant' || lng.startsWith('zh-TW')) {
          return 'zh-TW';
        }
        // 포르투갈어 브라질 변환: pt-BR → pt
        if (lng === 'pt-BR' || lng.startsWith('pt-BR')) {
          return 'pt';
        }
        // 필리핀어 변환: tl → fil
        if (lng === 'tl' || lng.startsWith('tl')) {
          return 'fil';
        }
        // 기본값: 하이픈 앞부분만 사용 (예: en-US → en)
        return lng.split('-')[0];
      }
    },
    
    backend: {
      loadPath: process.env.PUBLIC_URL + '/locales/{{lng}}/translation.json',
    },
    
    react: {
      useSuspense: true,
    },
    
    interpolation: {
      escapeValue: false,
    },
  });

// [진단용 로그 2] i18n 초기화 코드가 끝까지 실행되었는지 확인
debugLog("i18n.js: 초기화 코드 실행 완료");

export default i18n;